import { useEffect, useRef } from "react";

// Detects fast keyboard-wedge input (USB/Bluetooth HID barcode scanners) ending with Enter
export function useBarcodeScanner(onScan, { enabled = true, minLength = 4, maxGap = 60 } = {}) {
  const buf = useRef("");
  const last = useRef(0);
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => {
    if (!enabled) return;
    const handler = (e) => {
      const t = e.target;
      const inField = t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
      if (inField && !t.dataset.scanTarget) return;
      const now = Date.now();
      if (now - last.current > maxGap) buf.current = "";
      last.current = now;
      if (e.key === "Enter") {
        if (buf.current.length >= minLength && !inField) {
          e.preventDefault();
          cb.current(buf.current);
        }
        buf.current = "";
        return;
      }
      if (e.key.length === 1) buf.current += e.key;
    };
    window.addEventListener("keydown", handler, true);
    return () => window.removeEventListener("keydown", handler, true);
  }, [enabled, minLength, maxGap]);
}
